import { useMemo } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { AppTheme, Colors } from 'styles/theme';
import Flex from 'components/common/Flex';
import { useTranslation } from 'react-i18next';
import { isMobileDevice } from 'utils/helper';
import useDepsContainer from 'hooks/useDepsContainer';
import { AndroidAppSharedButton, IOSAppSharedButton, GroupSvg } from 'assets/icons';
import DownloadAndroidTop from 'assets/images/download-android-top.png';
import DownloadIosTop from 'assets/images/download-ios-top.png';
import DownloadApkTop from 'assets/images/download-apk-top.png';
import { useAppLink } from "hooks/useAppLink";

const Banner = () => {
  const styles = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const { uiStore } = useDepsContainer();

  const { t, i18n } = useTranslation();
  const cachedT = useMemo(() => t, [t, uiStore.language]);
  const { toAppStore, toGooglePlay ,goAPK } = useAppLink();

  return (
    <>
      <Flex className={styles.bannerWrap} column>
        <Flex className={smDown ? styles.bannerSm : mdDown ? styles.bannerMd : styles.banner} column>
          <Flex className={smDown ? styles.textSm : mdDown ? styles.textMd : styles.text} lang={uiStore.language}>
            {cachedT('HomeBanner1')}
          </Flex>
          <Flex className={smDown ? styles.textSm : mdDown ? styles.textMd : styles.text} lang={uiStore.language}>
            {cachedT('HomeBanner2')}
            <em></em>
          </Flex>
          <Flex className={smDown ? styles.descSm : mdDown ? styles.descMd : styles.desc}>
            {cachedT('HomeBannerDescritpion')}
          </Flex>

          <Flex mx={mdDown ? 8 : 8} cursorPointer>
            <Flex style={{ 'position': 'relative' }} onClick={toAppStore}>
              <img
                width={mdDown ? 101 : 155}
                height={mdDown ? 30 : 46}
                style={{ marginRight: mdDown ? '10px' : '16px' }}
                src={DownloadIosTop}
              />
              <div
                className={mdDown ? styles.downloadBtnMd : styles.downloadBtn}
                dangerouslySetInnerHTML={{ __html: t('DownloadIOS') }}
                lang={uiStore.language}
              />
            </Flex>
            <Flex style={{ 'position': 'relative' }} onClick={toGooglePlay}>
              <img
                width={mdDown ? 101 : 155}
                height={mdDown ? 30 : 46}
                style={{ marginRight: mdDown ? '10px' : '16px' }}
                src={DownloadAndroidTop}
              />
             <div className={mdDown ? styles.downloadBtnMd: styles.downloadBtn} dangerouslySetInnerHTML={{ __html: t('DownloadAndroid') }} lang={uiStore.language} />
            </Flex>
            <Flex style={{'position':'relative'}} onClick={goAPK}>
              <img
                width={mdDown ? 101 : 155}
                height={mdDown ? 30 : 46}
                src={DownloadApkTop}
              />
              <div className={mdDown ? styles.downloadBtnMd: styles.downloadBtn} dangerouslySetInnerHTML={{ __html: t('DownloadApk') }} lang={uiStore.language} />
            </Flex>
            {/* <IOSAppSharedButton width={mdDown ? 155 : 155} height={mdDown ? 46 : 46} onClick={toAppStore} /> */}
          </Flex>
          {/* <Flex mx={2} cursorPointer></Flex> */}

          {/* <Flex className={styles.watch}>
          Watch video<em className={styles.arrow}></em>
        </Flex> */}
        </Flex>
        {/* <Flex className={styles.text} fontSize={mdDown ? 48 : 120} fontWeight={400}></Flex> */}
        {/* <Flex mt={5} width={"100%"} center zIndex={2}>
        <Flex mx={2} cursorPointer onClick={toGooglePlay}>
          <AndroidAppSharedButton
            width={mdDown ? 164 : 273}
            height={mdDown ? 48 : 80}
          />
        </Flex>
        <Flex mx={2} cursorPointer onClick={toAppStore}>
          <IOSAppSharedButton
            width={mdDown ? 164 : 273}
            height={mdDown ? 48 : 80}
          />
        </Flex>
      </Flex> */}
        {/* {mdDown ? (
        <Flex className={styles.groupMd} mt={4} marginBottom={'-80px'} marginLeft={'-25px'}>
          <Flex className={styles.downTextMd}>Scroll down</Flex>
          <Flex marginLeft={'-25px'}>
            <GroupSvg width={13} height={28} />
          </Flex>
        </Flex>
      ) : (
        <Flex className={styles.group}>
          <Flex className={styles.downText}>Scroll down</Flex>
          <GroupSvg />
        </Flex>
      )} */}
      </Flex>
      {/* <Flex
        column
        style={{ padding: mdDown ? 0 : '0 24px', maxWidth: mdDown ? 'auto' : '1328px', margin: '0 auto' }}
        width={'100%'}
      >
        <Flex className={mdDown ? styles.videoTitleMd : styles.videoTitle}>
          {cachedT('HomeBannerVideoTitle')}
          <em></em>
        </Flex>
        <Flex className={mdDown ? styles.videoContentMd : styles.videoContent} center>
          {uiStore.language == 'cs' ? (
            <video src="images/video/introduction_pumpkin.mp4" poster="images/video/video.jpg" controls></video>
          ) : uiStore.language == 'vn' ? (
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/gOO0p8nMLJw?si=hJX7K6Bd5t-ayXsF"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          ) : (
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/scx5dvkUApU?si=wtgL7d_-JjE2MuO0"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          )}
        </Flex>
      </Flex> */}
    </>
  );
};

const useStyles = makeStyles((theme: AppTheme) =>
  createStyles({
    bannerWrap: {
      width: '100vw',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#FFF',
      marginTop: '72px'
    },
    banner: {
      width: '1440px',
      height: '883px',
      background: 'url(/images/home-banner.png) center no-repeat',
      backgroundSize: 'cover',
      position: 'relative',
      zIndex: 1,
      paddingLeft: '50px'
    },
    '@media screen and (min-width:1280px) and (max-width: 1440px)': {
      banner: {
        width: '1280px',
        height: '785px',
        background: 'url(/images/home-banner.png) center no-repeat',
        backgroundSize: 'cover',
        position: 'relative',
        paddingLeft: '50px'
      }
    },
    bannerSm: {
      width: '100%',
      maxWidth: '750px',
      height: '0',
      paddingBottom: '200%',
      background: 'url(/images/mobile/home-banner.png) center no-repeat',
      backgroundSize: 'contain',
      position: 'relative',
      zIndex: 1,
      paddingLeft: '0',
      marginTop: '-20px',
      paddingTop: '40px'
    },
    bannerMd: {
      width: '100%',
      height: '0',
      paddingBottom: '135.8%',
      background: 'url(/images/home-banner-lg.png) center no-repeat',
      backgroundSize: 'cover',
      position: 'relative',
      paddingLeft: '50px'
    },
    text: {
      // background: 'url(/images/banner-text-en.svg) center no-repeat',
      width: '1000px',
      //height: '227px',
      // backgroundSize: '665px 227px',
      fontSize: '96px',
      color: '#000',
      fontFamily: 'Lexend',
      paddingLeft: '28px',
      fontWeight: '900',
      lineHeight: '114px',
      textTransform: 'uppercase',
      position: 'relative',

      '&[lang="vn"]': {
        fontSize: '80px'
      },

      '&[lang="in"]': {
        fontSize: '80px'
      },

      '&:nth-child(1)': {
        marginTop: '85px'
      },

      '& em': {
        display: 'block',
        width: '56px',
        height: '38px',
        background: 'url(images/title-icon1.svg) center no-repeat',
        backgroundSize: '56px 38px',
        right: '-20px',
        top: '-20px'
      }
    },
    '@media screen and (min-width:840px) and (max-width: 1280px)': {
      banner: {
        width: '100%',
        height: '0',
        paddingBottom: '135.8%',
        background: 'url(/images/home-banner-lg.png) center no-repeat',
        backgroundSize: 'cover',
        position: 'relative',
        paddingLeft: '50px'
      },
      text: {
        '&:nth-child(1)': {
          marginTop: '190px'
        }
      }
    },
    textSm: {
      width: '100%',
      color: '#000',
      fontFamily: 'Lexend',
      paddingLeft: '0',
      fontWeight: '900',
      lineHeight: '60px',
      fontSize: '50px',
      textTransform: 'uppercase',
      position: 'relative',
      textAlign: 'center',
      justifyContent: 'center',
      letterSpacing: '-1px',

      '&:nth-child(1)': {
        marginTop: '85px'
      },

      '& em': {
        display: 'block',
        width: '56px',
        height: '38px',
        background: 'url(images/title-icon1.svg) center no-repeat',
        backgroundSize: '56px 38px',
        right: '-20px',
        top: '-20px'
      }
    },
    textMd: {
      width: 'calc(100% - 64px)',
      color: '#000',
      fontFamily: 'Lexend',
      paddingLeft: '0',
      fontWeight: '900',
      fontSize: '50px',
      lineHeight: '60px',
      textTransform: 'uppercase',
      position: 'relative',
      letterSpacing: '-1px',
      margin: '0 auto',

      '&:nth-child(1)': {
        marginTop: '145px'
      },

      '& em': {
        display: 'block',
        width: '56px',
        height: '38px',
        background: 'url(images/title-icon1.svg) center no-repeat',
        backgroundSize: '56px 38px',
        right: '-20px',
        top: '-20px'
      }
    },
    desc: {
      color: '#3B3C45',
      fontSize: '24px',
      fontStyle: 'normal',
      fontWeight: '300',
      lineHeight: '32px',
      width: '620px',
      marginTop: '25px',
      paddingLeft: '28px',
      marginBottom: '27px'
    },
    descSm: {
      color: '#3B3C45',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: '300',
      lineHeight: '28px',
      width: 'calc(100% - 64px)',
      paddingLeft: '0',
      justifyContent: 'center',
      margin: '45px auto 25px'
    },
    descMd: {
      color: '#3B3C45',
      fontSize: '24px',
      fontStyle: 'normal',
      fontWeight: '300',
      lineHeight: '32px',
      width: '50%',
      paddingLeft: '0',
      justifyContent: 'center',
      margin: '45px 0 25px 32px'
    },
    watch: {
      padding: '24px 22px',
      gap: '10px',
      borderRadius: '0px 5px 5px 0px',
      background: '#18181B',
      color: ' #FFF',
      textAlign: 'center',
      fontSize: '20px',
      fontWeight: '700',
      lineHeight: '20px',
      width: '193px',
      height: '68px',
      marginTop: '25px',
      marginLeft: '28px'
    },
    videoTitle: {
      color: '#18181B',
      textAlign: 'center',
      fontFamily: 'Lexend',
      fontSize: '64px',
      fontWeight: '900',
      lineHeight: '78px',
      margin: '85px auto 56px',

      '& em': {
        display: 'block',
        width: '55px',
        height: '61px',
        background: 'url(images/title-icon2.svg) center no-repeat',
        backgroundSize: '55px 61px',
        marginLeft: '-16px',
        marginTop: '-20px'
      }
    },
    videoTitleMd: {
      color: '#18181B',
      textAlign: 'left',
      fontFamily: 'Lexend',
      fontSize: '40px',
      fontWeight: '900',
      lineHeight: '48px',
      margin: '15px auto 10px',
      justifyContent: 'center',
      width: 'calc(100% - 64px)',

      '& em': {
        display: 'block',
        width: '28px',
        height: '31px',
        background: 'url(images/title-icon2.svg) center no-repeat',
        backgroundSize: '28px 31px',
        marginLeft: '-8px',
        marginTop: '40px'
      }
    },
    videoContent: {
      width: '100%',
      maxWidth: '1280px',
      height: '0',
      paddingBottom: '56.25%',
      borderRadius: '24px',
      background: '#000 url(images/home-play-circle.svg) center no-repeat',
      margin: '0 auto 40px',
      backgroundSize: '120px 120px',
      position: 'relative',

      '& video': {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        borderRadius: '24px'
      },

      '& iframe': {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        border: 'none',
        borderRadius: '24px'
      }
    },
    videoContentMd: {
      width: 'calc(100vw - 32px)',
      height: 'calc(56.25vw - 18px)',
      borderRadius: '24px',
      background: '#000 url(images/home-play-circle.svg) center no-repeat',
      margin: '0 auto 24px',
      backgroundSize: '40px 40px',

      '& video': {
        width: '100%',
        height: 'calc(56.25vw - 18px)',
        borderRadius: '24px'
      },

      '& iframe': {
        width: '100%',
        height: 'calc(56.25vw - 18px)',
        borderRadius: '24px'
      }
    },
    arrow: {
      background: 'url(/images/banner-arrow-right.svg) center no-repeat',
      width: '13px',
      height: '15px'
    },
    group: {
      position: 'absolute',
      bottom: 20,
      left: '45%'
    },
    groupMd: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    downText: {
      fontFamily: 'Lexend',
      transform: 'rotate(90deg) scale(0.8)',
      fontSize: '8px',
      letterSpacing: '-0.3px'
    },
    downTextMd: {
      fontFamily: 'Lexend',
      transform: 'rotate(90deg) scale(0.5)',
      fontSize: '8px',
      letterSpacing: '-0.3px'
    },
    downloadBtnMd: {
      position: 'absolute',
      top: '2px',
      left: '24px',
      transform: 'scale(0.8)',
      fontSize: '8px',
      color: '#FFF',
      lineHeight: '10px',

      '& strong': {
        fontFamily: 'Lexend',
        fontSize: '12px',
        display: 'block',
        lineHeight: '14px',
        letterSpacing: '-0.3px',
        fontWeight: '500',
        marginBottom: '1px',
        marginTop: '1px'
      },

      '&[lang="kr"]': {
        '& strong': {
          fontSize: '10px',
          letterSpacing: '-0.1px'
        }
      }
    },
    downloadBtn: {
      position: 'absolute',
      top: '6px',
      left: '42px',
      fontSize: '12px',
      color: '#FFF',
      lineHeight: '16px',
      marginBottom: '2px',

      '& strong': {
        fontFamily: 'Lexend',
        fontSize: '18px',
        display: 'block',
        lineHeight: '18px',
        letterSpacing: '-0.3px',
        fontWeight: '600',
        marginBottom: '2px'
      },

      '&[lang="kr"]': {
        fontSize: '10px',

        '& strong': {
          fontSize: '14px',
          letterSpacing: '-0.1px'
        }
      }
    }
  })
);

export default observer(Banner);
